import axios from "axios";
import { setToken, setRefreshToken, getToken, removeToken, removeRefreshToken } from './token';
import { refreshToken, isRefreshToken, getRefreshPromise } from './refreshToken';
import * as dd from 'dingtalk-jsapi';

let isRedirecting = false; // 防止重复跳转登录页
let loginMessageShown = false; // 防止重复提示登录失效

const ins = axios.create({
  baseURL:process.env.VUE_APP_BASE_API,
})

// 请求拦截器：动态设置 Authorization 头部
ins.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


ins.interceptors.response.use(
  async (res) => {
    // 更新 Token
    if (res.headers.Authorization) {
      const token = res.headers.Authorization.replace('Bearer ', '');
      setToken(token);
      ins.defaults.headers.Authorization = `Bearer ${token}`;
    }

    // 处理 401 错误
    if (res.data.code === 401 && res.data.message.indexOf('未登录授权') != -1 && !isRefreshToken(res.config)) {
      return handleRefreshToken(res.config);
    }
    return res.data;
  },
  (error) => {
    // 统一处理请求错误
    if (axios.isAxiosError(error) && error.response) {
      const { response } = error;
      if (response.status === 401 && !isRefreshToken(response.config)) {
        return handleRefreshToken(response.config);
      }
    }
    return Promise.reject(error);
  }
);

// 辅助函数：处理刷新 Token 的逻辑
async function handleRefreshToken(config) {
  // 如果已经有刷新操作在进行，等待它完成
  const existingPromise = getRefreshPromise();
  if (existingPromise) {
    console.log('等待正在进行的 token 刷新...');
    try {
      const isSuccess = await existingPromise;
      if (isSuccess) {
        config.headers.Authorization = `Bearer ${getToken()}`;
        return await ins.request(config);
      } else {
        // 发起方已经调用了 onGoLogin，等待方只需 reject，避免重复跳转
        return Promise.reject(new Error('Token 刷新失败'));
      }
    } catch (error) {
      // 发起方已经调用了 onGoLogin，等待方只需 reject
      return Promise.reject(error);
    }
  }

  // 没有正在进行的刷新，启动新的刷新
  if (isRedirecting) {
    return Promise.reject(new Error('正在重定向到登录页'));
  }

  isRedirecting = true;
  try {
    const isSuccess = await refreshToken();
    if (isSuccess) {
      config.headers.Authorization = `Bearer ${getToken()}`;
      isRedirecting = false;
      return await ins.request(config);
    } else {
      // 刷新失败，立即清除无效令牌，避免 1500ms 延迟期间仍有旧令牌残留
      // 保持 isRedirecting = true，防止后续 401 请求在跳转期间重复进入刷新流程
      removeToken();
      removeRefreshToken();
      onGoLogin(config.that);
      return Promise.reject(new Error('Token 刷新返回失败'));
    }
  } catch (error) {
    // 刷新异常，立即清除无效令牌
    removeToken();
    removeRefreshToken();
    onGoLogin(config.that);
    // 保持 isRedirecting = true，防止后续 401 请求在跳转期间重复进入刷新流程
    return Promise.reject(error);
  }
}

async function  onGoLogin(that){
  if (loginMessageShown) {
    return;
  }
  loginMessageShown = true;
  const fullPath = decodeURI(that.$router.history.current.fullPath).toLowerCase();

  // that.$message({
  //   message: '登录失效，请重新登陆！',
  //   type: "warning"
  // });
  setTimeout(function() {
    // 令牌已在 handleRefreshToken 中立即清除，此处不再重复操作
    // isRedirecting 不在此处重置，等待登录成功后由 resetAuthState 重置
    if (dd.env.platform !== "notInDingTalk") {
      that.$router.push({
        path: '/DingDing',
        query: {
          url: that.$router.history.current.fullPath,
        },
      });
    } else {
      if (fullPath.indexOf("login?url=") < 0) {
        that.$router.push({
          path: '/login',
          query: {
            url:  that.$router.history.current.fullPath,
          },
        });
      } else {
        that.$router.push({
          path:  that.$router.history.current.fullPath,
        });
      }
    }
    loginMessageShown = false;
    return false;
  }, 1500);
}

// 重置认证状态标志，由登录模块在登录成功后调用
export function resetAuthState() {
  isRedirecting = false;
  loginMessageShown = false;
}


export default ins;
